// extracted by mini-css-extract-plugin
export default {"loginHeader":"loginAside_loginHeader__gPgtx","loginIcon":"loginAside_loginIcon__HadmU"};